import { useTranslation } from "react-i18next";
import { OPEN_CONSENT_EVENT } from "@/components/site/cookie-consent";

export function CookieSettingsLink({ className }: { className?: string }) {
  const { t } = useTranslation("common");
  return (
    <button type="button" className={className} onClick={() => window.dispatchEvent(new Event(OPEN_CONSENT_EVENT))}>
      {t("consent.settings")}
    </button>
  );
}
